'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var R = require('ramda');
var __chunk_1 = require('./_virtual/_rollupPluginBabelHelpers.js');
var toFixed = require('./to-fixed.js');

function updateCount(factor, targetCount) {
  return function (state) {
    var roundingType = state.count < targetCount ? 'ceil' : 'floor';
    var delta = toFixed.toFixed(2, (targetCount - state.count) / factor);
    return {
      count: Math[roundingType](state.count + delta) || 0,
      run: delta > 1 / factor
    };
  };
}
/**
 * Create component with number easing applied to specified prop
 * @param {ReactComponent} Component
 * @param {object} options
 * @param {number} [options.factor=96] - Easing factor; smaller is faster
 * @param {string} options.propName - Prop to ease
 */


function withCountUp(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!options.propName) {
    throw new Error('options.propName is required');
  } // eslint-disable-next-line react/no-deprecated


  return (
    /*#__PURE__*/
    function (_React$Component) {
      __chunk_1.inherits(CountUp, _React$Component);

      function CountUp(props) {
        var _this;

        __chunk_1.classCallCheck(this, CountUp);

        _this = __chunk_1.possibleConstructorReturn(this, __chunk_1.getPrototypeOf(CountUp).call(this, props));
        _this.handleUpdate = _this.handleUpdate.bind(__chunk_1.assertThisInitialized(_this));
        _this.state = {
          count: props[options.propName] || 0
        };
        return _this;
      }

      __chunk_1.createClass(CountUp, [{
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          window.cancelAnimationFrame(this.requestID);
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          if (!Number.isNaN(this.props[options.propName])) {
            if (prevProps[options.propName] !== this.props[options.propName]) {
              this.handleUpdate(true);
            }

            if (this.state.count !== this.props[options.propName]) {
              window.cancelAnimationFrame(this.requestID);
              this.requestID = window.requestAnimationFrame(this.handleUpdate);
            }
          }
        }
      }, {
        key: "handleUpdate",
        value: function handleUpdate(force) {
          if (force || this.state.run) {
            this.setState(updateCount(options.factor || 96, this.props[options.propName]));
          }
        }
      }, {
        key: "render",
        value: function render() {
          return React__default.createElement(Component, R.assoc(options.propName, Math.round(this.state.count), this.props));
        }
      }]);

      return CountUp;
    }(React__default.Component)
  );
}

exports.withCountUp = withCountUp;
//# sourceMappingURL=with-count-up.js.map
